import React from "react";
import Navbar from "../../components/Navbar";
import Hero from "../../components/Hero";
import Overview from "../../components/Overview";
import Advantages from "../../components/Advantages";
import Utilities from "../../components/Utilities";
import Roadmap from "../../components/Roadmap";
import Team from "../../components/Team";
import Socials from "../../components/Socials";
import Faq from "../../components/Faq";
import Footer from "../../components/Footer";

import { Box } from "@chakra-ui/react";

function index() {
  return (
    <Box position="relative">
      <Navbar />
      <Hero />
      <Overview />
      <Advantages />
      <Utilities />
      <Roadmap />
      <Team />
      <Socials />
      <Faq />
      <Footer />
    </Box>
  );
}

export default index;
